export default __webpack_public_path__ + "static/media/next-airstrapz.3da9594c.jpg";